import createReactClass from 'create-react-class'

import { connect } from 'react-redux'
import { selectAction, shouldBeShownAction } from './actions'

import Radium from 'radium'
import React from 'react'
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import FilterIcon from '@material-ui/icons/FilterList';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import FilterContainer from './FilterContainer';
import TypeAheadComponent from './TypeAheadComponent';

import 'font-awesome/css/font-awesome.min.css';

const suggestions = (() => {
  return [{label: 'test1'}, {label: 'test2'}]
})();

function getSuggestions(value) {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : suggestions.filter(suggestion => {
        const keep =
          count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

const SearchResults = connect(
  (state => {
    return {
      searchResults: state.searchResults,
      filteredResults: state.filteredResults,
      isWaitingForResponse: state.isWaitingForResponse,
      shouldBeShownIds: state.shouldBeShownIds,
    }
  }),
  (dispatch => {
    return {
      onSelectClick: selected => dispatch(selectAction(selected)),
      shouldBeShown: ids => dispatch(shouldBeShownAction(ids)),
    }
  })
  )(createReactClass({
  spinnerStyles: {
    margin: '25% 15%',
    position: 'absolute',
  },
  containerStyles: {
    display: 'flex'
  },
  listSubheaderStyles:{
    backgroundColor: "#F9F9F9",
  },
  componentWillUpdate(newProps) {
    const { searchResults, shouldBeShown, filteredResults } = newProps

    if (this.props.searchResults !== searchResults || this.props.filteredResults !== filteredResults) {
      const filterIds = filteredResults ? filteredResults.map(({id}) => id) : null

      let totalResults = null
      if (searchResults && filterIds) {
        //console.log('total results from filter & search')
        totalResults = searchResults.filter(({feature_id}) => filterIds.includes(feature_id))
      } else if (searchResults) {
        //console.log('total results from search')
        totalResults = searchResults
      } else if (filteredResults) {
        //console.log('total results from filter')
        totalResults = filteredResults.map((f) => {return {
            feature_id: f.id,
            headline: f.headline,
            address: f.address
          }
        })
      } else {
        //console.log('total results absent')
        null
      }
      shouldBeShown(totalResults)
    }
  },
  render: function() {
    const { shouldBeShownIds, onSelectClick, isWaitingForResponse, classes } = this.props

    const resultsCount = shouldBeShownIds && shouldBeShownIds.length
    
    if (isWaitingForResponse) {
      return (
        <div id='search-results' style={this.containerStyles}>
          <CircularProgress size={100} className={classes.progress} style={this.spinnerStyles}/>
        </div>
      )
    } else if (shouldBeShownIds) {
      console.log('rendering search results: ' + resultsCount)
        return (
        <div id='search-results' style={this.containerStyles}>
          <List dense={true} subheader={<ListSubheader  style={this.listSubheaderStyles}>
              {resultsCount ? 
                <Typography>
                  Найдено объектов: {resultsCount}  
                  <Button
                    onClick={() => {
                      //открываем новое окно и печатаем результаты
                      const searchResults = document.getElementById('search-results');
                      let printing = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
                      printing.document.write(
                        searchResults.innerHTML.replace(
                          'ul', 'ol type="1"'
                        ).replace(
                          'li', 'li style="display: none"'
                        ).replace(
                          /div tabindex="0"/g, 'li'
                        )
                      );
                      printing.document.close();
                      printing.focus();
                      printing.print();
                      printing.close();
                    }}
                  >
                    Печать</Button>
                </Typography> 
                : 'Ничего не найдено'}
          </ListSubheader>}>
            {shouldBeShownIds.map(({feature_id, headline, address}) =>
              <ListItem button key={'search_result_' + feature_id} onClick={() => onSelectClick(feature_id)}>
                <ListItemText
                  primary={<div dangerouslySetInnerHTML={{__html: headline}}></div>}
                  secondary={address}
                />
              </ListItem>
            )}  
          </List>
        </div>
      )
    } else {
      return (
        <div id='search-results' style={this.containerStyles}>
          <List dense={true} subheader={<ListSubheader style={this.listSubheaderStyles}>
            {resultsCount ? `Найдено объектов ${resultsCount}` : null}
            </ListSubheader>}></List>
        </div>
      )
    }
  }
}));

const SearchComponent = createReactClass({
  filterStyles: {
    margin: '0px 0px 0px 10px'
  },
  filterPanelStyles: {
    transition: 'all 500ms linear'
  },
  filterContainerStyles: {
    overflowY: 'visible',
    display: 'block',
  },

  onClick: function (id) {
    const { onSelectClick } = this.props
    console.log('search list selection: ' + id)
    onSelectClick(id)
  },
  getSearch: async function (query) {
    let response = await fetch(`/api/search?query=${query}`, {credentials: 'include'})
    let data = await response.json()
    return data['matches'] && data['matches'][0] || []
  },
  handleSearchChange: async function (value) {
    const { onSearchChanged, onSearchResults, waitingForResponse } = this.props;
    waitingForResponse(true)
    onSearchChanged(value)
    const results = await this.getSearch(value)
    onSearchResults(results)
    waitingForResponse(false)
  },
  render: function () {
    const { isWaitingForResponse,
      classes, showingFilters, changeShowFilters } = this.props
    return (
     <div className='flex-content-row' style={{'display': 'flex', 'flexDirection': 'row', 'overflowY': 'scroll'}}>
      <div className='flex-content'
        style={{'display': 'flex', 'flexDirection': 'column', 'flexBasis': '50%', 'flexGrow': 1}}>
        <div 
          className='search-controls' 
          style={{'display': 'flex', 'width': '100%', 'flexShrink': 0}}
        >
          <div style={{'display': 'inline-flex', 'flexGrow': 0.8}}>
          <div style={{paddingLeft: '20px','flexGrow': 5}}>
          <TypeAheadComponent
            getSuggestions={getSuggestions}
            parentSearchChangeHandler={(v) => this.handleSearchChange(v)}
          />
          </div>
          <div style={this.filterPanelStyles}>
              <Button 
                color="primary"
                className={classes.button} 
                onClick={() => changeShowFilters(!showingFilters)}
                style={this.filterStyles}
              >
                <FilterIcon />  Фильтр
              </Button>
          </div>
          </div>
        </div>
        <div style={{'display': 'flex', 'overflow': isWaitingForResponse ? 'visible' : 'auto'}}>
        <SearchResults
          classes={classes}
        />
        </div>
      </div>
      <div style={{...this.filterContainerStyles, ...{display: showingFilters ? 'flex' : 'none', flexBasis: '50%'}}}>
        <FilterContainer />
      </div>
      </div>
    )
  }
})

const styles = (theme => ({
      button: {
        margin: theme.spacing.unit,
      },
      input: {
        display: 'none',
      },
  }))

export default Radium(withStyles(styles)(SearchComponent))



// WEBPACK FOOTER //
// ./src/SearchComponent.js